module.exports = __webpack_public_path__ + "static/media/taripuru.6e3d8dce.webp";